    import axios from 'axios';
    import constants from './../../../../utils/constants';
    import { getToken } from "./../../../../utils/Authentication";
    const fileDownload = require('js-file-download');

    export function getActivityList(data, callback) {
        return function (dispatch) {
            dispatch({ type: "ACTIVITY_LOGS_LIST" });
            const headers = {
                'Authorization': `Bearer ${getToken() || ''}`,
                'Content-Type': 'application/json'
            };
            axios
                .post(constants.BASE_URL + `accounts/activitylog/dashboard`, data, { headers })
                .then((response) => {
                    if (response && response.data && response.data.success === 0 && response.data.logout === true) {
                        sessionStorage.removeItem('token');
                        window.sessionStorage.removeItem("userDetails");
                        localStorage.removeItem("UserBusinessDetails");
                        window.location.href = '/login';

                    } else {
                        // console.log('response', response.data);
                        dispatch({
                            type: "ACTIVITY_LOGS_LIST_SUCCESS",
                            payload: response.data.data,

                        });
                        callback(response.data);
                    }
                })
                .catch((error) => {
                    // console.log(error)


                })
        }
    };
    export async function downloadActivityLogs(data1, userId) {
    const headers = {
        Authorization: `Bearer ${getToken() || ""}`,
    };

    data1["fileType"] = "EX";

    const config = {
        method: "post",
        url: `${constants.BASE_URL}accounts/activitylog/dashboard/download`,
        headers,
        data: data1,
        responseType: "arraybuffer",
    };

    try {
        const response = await axios(config);

        if (response.status === 204) {
        return {
            status: 0,
            message: "No Inventories Data",
            data: [],
        };
        }

        if (
        response.status === 200 &&
        response.headers &&
        response.headers["content-disposition"]
        ) {
        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });

        fileDownload(blob, "inventories.xlsx");

        return {
            status: 1,
            message: "Downloaded Successfully",
        };
        }

        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
    } catch (error) {
        console.error("Excel download failed", error);
        return {
        status: -1,
        message: "Download failed",
        error,
        };
    }
    }
